import { get, post, httpDelete, getQSFromObject } from './common';
import {
	WhiteboardData,
	WhiteboardUpdateRequest,
	WhiteboardJoinResponse,
	WhiteboardHistoryData,
	WhiteboardSnapshotRequest,
	WhiteboardSaveFileRequest,
	WhiteboardFile,
} from '../Types/whiteboard';

const whiteboardEndpoint = 'api/whiteboard';

export async function getWhiteboard(objectType: number, objectId: number) {
	const endpoint = `${whiteboardEndpoint}/GetWhiteboard?${getQSFromObject({ objectType, objectId })}`;
	const result = await get<WhiteboardData | null>(endpoint);
	return result;
}

export async function saveWhiteboard(whiteboard: WhiteboardUpdateRequest) {
	const endpoint = `${whiteboardEndpoint}/SaveWhiteboard`;
	const result = await post<WhiteboardData>(endpoint, whiteboard);
	return result;
}

export async function deleteWhiteboard(whiteboardId: number) {
	const endpoint = `${whiteboardEndpoint}/DeleteWhiteboard?${getQSFromObject({ whiteboardId })}`;
	await httpDelete(endpoint);
}

// New cache-backed methods
export async function joinWhiteboard(objectType: number, objectId: number) {
	const endpoint = `${whiteboardEndpoint}/JoinWhiteboard?${getQSFromObject({ objectType, objectId })}`;
	const result = await get<WhiteboardJoinResponse>(endpoint);
	return result;
}

export async function createSnapshot(request: WhiteboardSnapshotRequest) {
	const endpoint = `${whiteboardEndpoint}/CreateSnapshot`;
	const result = await post<WhiteboardHistoryData>(endpoint, request);
	return result;
}

export async function saveWhiteboardFile(whiteboardId: number, file: WhiteboardFile) {
	const data: WhiteboardSaveFileRequest = {
		whiteboardId,
		file,
	};
	const endpoint = `${whiteboardEndpoint}/SaveFile`;
	await post(endpoint, data);
}

// Yjs updates are now sent via SignalR only - no API call needed

export async function getLatestSnapshot(whiteboardId: number) {
	const endpoint = `${whiteboardEndpoint}/GetLatestSnapshot?${getQSFromObject({ whiteboardId })}`;
	const result = await get<WhiteboardHistoryData | null>(endpoint);
	return result;
}

export async function getSnapshotHistory(whiteboardId: number, maxResults = 10) {
	const endpoint = `${whiteboardEndpoint}/GetSnapshotHistory?${getQSFromObject({ whiteboardId, maxResults })}`;
	const result = await get<WhiteboardHistoryData[]>(endpoint);
	return result || [];
}
